<section>
  <h1 class="title">Bursary reporting</h1>
  <mat-accordion [multi]="true">
    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title>Fund spending</mat-panel-title>
      </mat-expansion-panel-header>
      <p class="total-spending">
        Total spending: {{ fundSpendingTotal | customCurrency }}
      </p>
      @for (item of fundSpending; track item) {
        <section class="spending-chart-item">
          <section class="label">{{ item.name }}</section>
          <section class="progress-bar-container">
            <section
              class="progress-bar"
              [style.width]="getFundSpendingBarWidth(item.amount)"
              [style.backgroundColor]="item.color"
            ></section>
          </section>
          <p class="amount">{{ item.amount | customCurrency }}</p>
        </section>
      }
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Spending by university</mat-panel-title>
      </mat-expansion-panel-header>
      <p class="total-spending">
        Total spending: {{ universitySpendingTotal | customCurrency }}
      </p>
      @for (item of universitySpending; track item) {
        <section class="spending-chart-item">
          <p class="label">{{ item.name }}</p>
          <section class="progress-bar-container">
            <section
              class="progress-bar"
              [style.width]="getUniversitySpendingBarWidth(item.amount)"
              [style.backgroundColor]="'#777777'"
            ></section>
          </section>
          <p class="amount">{{ item.amount | customCurrency }}</p>
        </section>
      }
    </mat-expansion-panel>
  </mat-accordion>
</section>
